module.exports = __webpack_public_path__ + "img/member_message_icon_431005.c537b8c2.png";